import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAll,
  clearResetBot,
  onGetAdditionalDocuments,
  onGetComments,
  setCertificateDetails,
  setErrorMessageTransfereeUser,
  setLoadingTransfereeUser,
  showCertificateUpdateFormFunc,
  showRequestBalanceFunc,
  showResendLinkConfirmationFunc,
} from "../../../../config/redux/slice/transfereeUserSlice";
import { pagesText } from "../../../../constants/english";
import {
  getExtension,
  transformFirstLetter,
} from "../../../../helpers/helpers";
import { getFileRequest, getRequest } from "../../../../helpers/request";
import { appApi } from "../../../../utils/endpoints/appApi";
import { CardLayout, CertificateWrapper } from "../../../components";
import CertificateDetailsComponent from "../CertificateDetailsComponent";
import StatusChangeConfirmation from "../StatusChangeConfirmation";
import {
  showCommentFormFunc,
  showStatusChangeConfirmationFunc,
  setConfirmationStatusModalText,
  setCertificateDetailsGeneral,
} from "../../../../config/redux/slice/appSlice";
import ResendLinkConfirmation from "./ResendLinkConfirmation";
import BalanceRequestForm from "./BalanceRequestForm";
import { Link } from "react-router-dom";
import CertificateComments from "../CertificateComments";
import ApplicationDocuments from "../ApplicationDocuments";
import EditCertificateUploadForm from "./EditCertificateUploadForm";
import { CERTIFICATE_STATUS } from "../../../../constants";
import { convertDateTime } from "../../../../utils/lib";

export default function TransfereeCertificateView() {
  const dispatch = useDispatch();

  const {
    // bankUserLoading,
    // bankUserErrorMsg,
    // bankUserSuccessMsg,
    certificateManagement: {
      comments,
      newComment,
      certificateDetails,
      showResendLinkConfirmation,
      showRequestBalance,
      additionalDocs,
      showCertificateUpdateForm,
      updCertificate,
    },
  } = useSelector((state) => state.transfereeUser);

  const {
    // bankUserLoading,
    // bankUserErrorMsg,
    // bankUserSuccessMsg,
    isRefreshed,
    certificateManagement: {
      showStatusChangeConfirmation,
      certificateStatus,
      certificateStatusConfirmationBtnText,
    },
  } = useSelector((state) => state.app);

  // const [isExpanded, setIsExpanded] = useState(false)
  // const [status, setStatus] = useState('')
  // const [btnText, setBtnText] = useState('')

  const { token, userData } = useSelector((state) => state.authData);

  useEffect(() => {
    // getAllComments()
    if (isRefreshed == "") {
      getSingleCertificate();
    }
    getAdditionalDocs();
  }, []);

  const removeCommentFromHeader = (e, idValue, classValue) => {
    let element = document.getElementById(`${idValue}`);
    let elementAll = document.getElementsByClassName(`${classValue}`);
    for (let x = 0; x < elementAll.length; x++) {
      elementAll[x].style.display = "block";
    }
    if (e.currentTarget.classList.contains("collapsed")) {
      element.style.display = "none";
    }
  };

  const getAllComments = async () => {
    let id = certificateDetails?.ID;
    const res = await getRequest(
      token,
      `${appApi.getComments(id)}`,
      {},
      dispatch,
      setLoadingTransfereeUser,
      onGetComments,
      setErrorMessageTransfereeUser,
    );
    //   if(res !== undefined && res.status < 400){
    //       setBanks(res.data.data)
    //   }
  };

  const getAdditionalDocs = async () => {
    const res = await getRequest(
      token,
      `${appApi.getAdditionalDocuments(certificateDetails.ID)}`,
      {},
      dispatch,
      "",
      onGetAdditionalDocuments,
      "",
    );
  };

  const getSingleCertificate = async () => {
    const res = await getRequest(
      token,
      `${appApi.getSingleCertificate(certificateDetails.ID)}`,
      {},
      dispatch,
      "",
      "",
      "",
    );
    if (res != undefined && res.status < 400) {
      dispatch(
        setCertificateDetailsGeneral({ details: res.data.data, modal: false }),
      );
      dispatch(setCertificateDetails({ details: res.data.data, modal: false }));
    }
  };

  useEffect(() => {
    if (newComment) {
      getAllComments();
      dispatch(clearResetBot());
    }
  }, [newComment]);

  useEffect(() => {
    if (updCertificate) {
      getAdditionalDocs();
      dispatch(clearResetBot());
    }
  }, [updCertificate]);

  return (
    <CertificateWrapper>
      {showResendLinkConfirmation && (
        <ResendLinkConfirmation backdrop={showResendLinkConfirmation} />
      )}
      {showRequestBalance && (
        <BalanceRequestForm backdrop={showRequestBalance} />
      )}
      {showStatusChangeConfirmation && (
        <StatusChangeConfirmation
          certificateID={certificateDetails?.ID}
          status={certificateStatus}
          btnText={certificateStatusConfirmationBtnText}
        />
      )}
      {showCertificateUpdateForm && (
        <EditCertificateUploadForm certificateObject={certificateDetails} />
      )}
      <CardLayout
        cardTitle={"Certificate Details"}
        cardButtons={<AddCertificateButton />}
      >
        <div className="row d-flex">
          <section className="col-lg-5 certificate-comment-container">
            <ul
              className="nav nav-underline-active-primary mb-3"
              id="pills-tab1"
              role="tablist"
            >
              <li
                onClick={() => {
                  dispatch(
                    setConfirmationStatusModalText({
                      documentType: "Certificate",
                    }),
                  );
                }}
                className="nav-item"
              >
                <a
                  className="nav-link active"
                  id="pills-details-tab"
                  data-toggle="pill"
                  href="#nav-tabs-details"
                  role="tab"
                  aria-controls="nav-details"
                  aria-selected="true"
                >
                  Details
                </a>
              </li>
              <li
                onClick={() => {
                  dispatch(
                    setConfirmationStatusModalText({
                      documentType: "Certificate of Reasonableness",
                    }),
                  );
                }}
                className="nav-item"
              >
                <a
                  className="nav-link"
                  id="nav-comments-tab"
                  data-toggle="pill"
                  href="#nav-tab-comments"
                  role="tab"
                  aria-controls="nav-comments"
                  aria-selected="false"
                >
                  Comments
                </a>
              </li>
            </ul>
            <div className="tab-content mt-5 mt-md-0" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-tabs-details"
                role="tabpanel"
                aria-labelledby="pills-details-tab"
              >
                <CertificateDetailsComponent
                  certificateObject={certificateDetails}
                />
              </div>

              <div
                className="tab-pane fade"
                id="nav-tab-comments"
                role="tabpanel"
                aria-labelledby="nav-comments-tab"
              >
                <CertificateComments certificateObject={certificateDetails} />
              </div>
            </div>
          </section>
          <section className="col-lg-7 certificate-img-container">
            <ul
              className="nav nav-underline-active-primary mb-3"
              id="pills-tab2"
              role="tablist"
            >
              <li
                onClick={() => {
                  dispatch(
                    setConfirmationStatusModalText({
                      documentType: "Certificate",
                    }),
                  );
                }}
                className="nav-item"
              >
                <a
                  className="nav-link active"
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#nav-tabs-home2"
                  role="tab"
                  aria-controls="nav-tabs"
                  aria-selected="true"
                >
                  Documents
                </a>
              </li>
              {/* <li onClick={()=>{setDocumentType('Certificate Of Reasonableness')}} className="nav-item">
                    <a className="nav-link" id="nav-profile-tab" data-toggle="pill" href="#nav-profile2" role="tab"
                      aria-controls="nav-profile" aria-selected="false">Certificate Of Reasonableness</a>
                  </li> */}
            </ul>
            <div className="tab-content mt-5 mt-md-0" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-tabs-home2"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <ApplicationDocuments
                  certificateObject={certificateDetails}
                  additionalDocs={additionalDocs}
                />
              </div>
            </div>
          </section>
        </div>
      </CardLayout>
    </CertificateWrapper>
  );
}

function AddCertificateButton() {
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.authData);
  const {
    certificateManagement: { certificateDetails, additionalDocs },
  } = useSelector((state) => state.transfereeUser);

  const downloadFiles = async () => {
    dispatch(clearAll({}));

    const created_at = convertDateTime(
      certificateDetails?.CREATED_AT,
      pagesText.full_date_for_download,
    );
    const additionalDocuments = additionalDocs.map((document) => ({
      url: document.FILE_URL,
      name: `${document.FILE_NAME}_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
      ext: getExtension(document.FILE_URL),
    }));

    const urls = [
      {
        url: certificateDetails?.CERTIFICATE_FILE_PATH,
        name: `certificate_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.CERTIFICATE_FILE_PATH),
      },
      {
        url: certificateDetails?.STAMPED_AGREEMENT,
        name: `stamped_agreement_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.STAMPED_AGREEMENT),
      },
      {
        url: certificateDetails?.COVER_LETTER,
        name: `cover_letter_${certificateDetails?.CERTIFICATE_NUMBER}_${created_at}`,
        ext: getExtension(certificateDetails?.COVER_LETTER),
      },
      ...additionalDocuments,
    ];

    await getFileRequest(
      token,
      dispatch,
      setLoadingTransfereeUser,
      setErrorMessageTransfereeUser,
      `Application_Documents_${created_at}`,
      urls,
    );
  };

  const canRequestBalance = useMemo(() => {
    const details = certificateDetails;

    const rawValue = certificateDetails?.CAN_REQUEST_BALANCE;
    console.log({
      raw: rawValue,
      type: typeof rawValue,
      asNumber: Number(rawValue),
      isEqual: Number(rawValue) === 1,
    });

    // 1. Explicitly check for the permission flag
    const hasPermission = Number(rawValue) !== undefined;

    // 2. Ensure amount is not null/undefined (allows 0)
    const hasAmount =
      details?.AMOUNT_AVAILABLE !== 1 && details?.AMOUNT_AVAILABLE !== null;

    // 3. Define restricted statuses
    const restrictedStatuses = [
      CERTIFICATE_STATUS.DISAPPROVED,
      CERTIFICATE_STATUS.REJECTED,
    ];

    // 4. Check if current status is allowed
    const statusIsAllowed =
      details?.CERTIFICATE_STATUS &&
      !restrictedStatuses.includes(details.CERTIFICATE_STATUS);

    return hasPermission && hasAmount && statusIsAllowed;
  }, [certificateDetails]);

  const handleConfirmDisbursement = () => {
    dispatch(setConfirmationStatusModalText({ status: "confirmed" }));
    dispatch(
      setConfirmationStatusModalText({ btnText: "Confirm Disbursment" }),
    );
    dispatch(showStatusChangeConfirmationFunc({ modal: true }));
  };

  return (
    <div
      style={{ columnGap: "1.2rem", rowGap: "0.7rem" }}
      className="d-flex pt-md-2 flex-wrap align-items-center"
    >
      {certificateDetails?.CERTIFICATE_STATUS !== CERTIFICATE_STATUS.CLOSED && (
        <div className="dropdown">
          <button
            className="btn btn-sm btn-primary dropdown-toggle text-white"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-display="static"
          >
            Action
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <Link
              to={`/certificates/${encodeURIComponent(
                certificateDetails.CERTIFICATE_NUMBER,
              )}/transaction-history`}
              className="dropdown-item"
            >
              View Transaction History
            </Link>

            {!certificateDetails?.AMOUNT_AVAILABLE && (
              <button
                onClick={() =>
                  dispatch(showResendLinkConfirmationFunc({ modal: true }))
                }
                className="dropdown-item"
              >
                Resend Link to Bank Contact
              </button>
            )}
            {certificateDetails?.CERTIFICATE_STATUS ===
              CERTIFICATE_STATUS.DISBURSED && (
              <button
                className="dropdown-item"
                onClick={handleConfirmDisbursement}
              >
                Confirm Disbursement
              </button>
            )}
            {certificateDetails?.CERTIFICATE_STATUS ===
              CERTIFICATE_STATUS.REJECTED && (
              <button
                className="dropdown-item"
                onClick={() =>
                  dispatch(showCertificateUpdateFormFunc({ modal: true }))
                }
              >
                Update Information
              </button>
            )}

            {canRequestBalance && (
              <button
                onClick={() =>
                  dispatch(showRequestBalanceFunc({ modal: true }))
                }
                className="dropdown-item"
              >
                Request Balance
              </button>
            )}
          </div>
        </div>
      )}

      <button
        title="Download files"
        className="btn btn-sm btn-outline-primary"
        onClick={downloadFiles}
      >
        <i className="mdi mdi-arrow-down mr-1"></i>
        Download files
      </button>
    </div>
  );
}
